import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class SideMenu extends Component {
	render() {
		const { event, eventId, selectedMenuItemIndex, selectedMenuItemName } = this.props;
		let { section, sectionId } = this.props;
		if (event) {
			section = event;
			sectionId = eventId;
		}
		return (
			<div>
				{/* <Link className="backButton" to="/admin/events">
					<i className="las la-angle-left" />
					<div className="calibreBold fs-16">Back to Events</div>
				</Link> */}
				<div className="sideMenu">
					<div className="sideMenuContainer">
						{/* {eventMenuImage && eventMenuImage !== '' ? (
							<div className="eventMenuImageContainer">
								{' '}
								<img className="eventMenuImage" src={eventMenuImage} />
							</div>
						) : (
							<div className="eventMenuImageContainer">
								{' '}
								<img className="eventMenuImage" src={defaultImage} />
							</div>
						)} */}
						{this.props.menuItems.map((menuItem, index) => {
							if (menuItem.disabled) return null;
							if (index === selectedMenuItemIndex) {
								if (menuItem.isDropdown) {
									return (
										<div className="dropdownMenuItem" key={`menuItem-${index}`}>
											<Link
												to={
													menuItem.target ? (
														menuItem.target
													) : (
														`/admin/events/${sectionId}/${menuItem.section}/`
													)
												}
												className="menuItem fs-21"
											>
												<div className="menuItemIcon mr-5">
													<i
														className="las la-angle-down"
														style={{ fontSize: 15, paddingBottom: 10 }}
													/>{' '}
												</div>
												<div className="menuItemName">
													{menuItem.name}
													{menuItem.countKey && section[menuItem.countKey] ? (
														<span className="calibreRegular ml-10 lightGray">
															({section[menuItem.countKey]})
														</span>
													) : (
														''
													)}
												</div>
											</Link>
											{menuItem.dropdownItems.map((dropdownItem, index) => {
												if (dropdownItem.disabled) return null;
												return dropdownItem.name === selectedMenuItemName ? (
													<Link
														className="submenuItem menuItem selected"
														to={
															dropdownItem.target ? (
																dropdownItem.target
															) : (
																`/admin/events/${sectionId}/${dropdownItem.section}/`
															)
														}
														key={`menuLink-${index}`}
													>
														<div className="menuItemName">
															{dropdownItem.name}
															{dropdownItem.countKey && section[dropdownItem.countKey] ? (
																<span className="calibreRegular ml-10 lightGray">
																	({section[dropdownItem.countKey]})
																</span>
															) : (
																''
															)}
														</div>
													</Link>
												) : (
													<Link
														to={
															dropdownItem.target ? (
																dropdownItem.target
															) : (
																`/admin/events/${sectionId}/${dropdownItem.section}/`
															)
														}
														className="submenuItem menuItem"
														key={`menuLink-${index}`}
													>
														<div className="menuItemName">
															{dropdownItem.name}
															{dropdownItem.countKey && section[dropdownItem.countKey] ? (
																<span className="calibreRegular ml-10 lightGray">
																	({section[dropdownItem.countKey]})
																</span>
															) : (
																''
															)}
														</div>
													</Link>
												);
											})}
										</div>
									);
								}
								return (
									<Link
										to={
											menuItem.target ? (
												menuItem.target
											) : (
												`/admin/events/${sectionId}/${menuItem.section}/`
											)
										}
										className="menuItem selected fs-21"
										key={`menuItem-${index}`}
									>
										{menuItem.icon}{' '}
										<div className="menuItemName ml-5">
											{menuItem.name}
											{menuItem.countKey && section[menuItem.countKey] ? (
												<span className="calibreRegular ml-10 lightGray">
													({section[menuItem.countKey]})
												</span>
											) : (
												''
											)}
										</div>
									</Link>
								);
							}
							return (
								<Link
									to={
										menuItem.target ? (
											menuItem.target
										) : (
											`/admin/events/${sectionId}/${menuItem.section}/`
										)
									}
									className="menuItem fs-21"
									key={`menuItem-${index}`}
								>
									{menuItem.icon}{' '}
									<div className="menuItemName">
										{menuItem.name}
										{menuItem.countKey && section[menuItem.countKey] ? (
											<span className="calibreRegular ml-10 lightGray">
												({section[menuItem.countKey]})
											</span>
										) : (
											''
										)}
									</div>
								</Link>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}

export default SideMenu;
